import { rotaDeInstrumentos } from "@/views/Seguranca";

const metaPadrao = {
  subject: ["Produto"],
  action: ["read"],
  showMenu: true,
  grupo: "Produto",
  grupoTitle: "Produto",
};

export default [
  {
    path: "/produto",
    name: "Todos Produtos",
    component: () => import("@/views/Produto/DashboardProduto.vue"),
    meta: {
      breadcrumb: "",
      title: "Todos Produtos",
      icon: "mdi-text-box-multiple-outline",
      ...metaPadrao,
    },
  },
  {
    path: "/produto/taf",
    name: "TAF Produtos",
    component: () => import("@/views/Produto/DashboardTaf.vue"),
    meta: {
      breadcrumb: "",
      title: "TAF Produtos",
      icon: "mdi-text-box-multiple-outline",
      subject: ["TAF"],
      showMenu: true,
      grupo: "Produto",
      grupoTitle: "Produto",
    },
  },
  {
    path: "/produto/taf/visualizar",
    name: "Visualizar TAF Produto",
    component: () => import("@/views/Produto/VisualizacaoRit.vue"),
    meta: {
      breadcrumb: "",
      title: "Visualizar TAF Produto",
      icon: "mdi-text-box-multiple-outline",
      subject: ["TAF"],
      showMenu: false,
      grupo: "Produto",
      grupoTitle: "Produto",
    },
  },
  {
    path: "/produto/taf/garantia",
    name: "Certificado de Garantia",
    component: () => import("@/views/Produto/CertificadoGarantia.vue"),
    meta: {
      breadcrumb: "Todas as Fabricações",
      title: "Certificado de Garantia",
      icon: "mdi-text-box-multiple-outline",
      subject: ["TAF"],
      showMenu: false,
      grupo: "Produto",
      grupoTitle: "Produto",
    },
  },
  {
    path: "/produto/checklist",
    name: "Checklist do Produto",
    component: () => import("@/views/Produto/Checklist/DashboardChecklist.vue"),
    meta: {
      breadcrumb: "",
      title: "Checklist",
      icon: "mdi-format-list-checks",
      subject: ["TAF"],
      showMenu: true,
      grupo: "Produto",
      grupoTitle: "Produto",
    },
  },
  ...rotaDeInstrumentos,
];
